export default Object.freeze({
  forecast: {
    id: 'forecast',
    name: 'Forecast',
    description: `Draw, look at, and rearrange the top 6 cars of the Infection Deck.
      Put them back on top.`
  },
  one_quiet_night: {
    id: 'one_quiet_night',
    name: 'One Quiet Night',
    description: `Skip the next Infect Cities step (do not flip over any Infection cards).`
  },
  gov_grant: {
    id: 'gov_grant',
    name: 'Government Grant',
    description: `Add 1 research station to any city (no City card needed).`
  },
  res_pop: {
    id: 'res_pop',
    name: 'Resilient Population',
    description: `Remove any 1 card in the Infection Discard Pile from the game.
      You may play this between the Infect and Intensify steps of an epidemic.`
  },
  airlift: {
    id: 'airlift',
    name: 'Airlift',
    description: `Move any 1 pawn to any city. Get permission before moving another player's pawn.`
  }
});



/** WEBPACK FOOTER **
 ** ./src/constants/events.js
 **/